import { List as InnerList, ListItem as InnerListItem, ListItemHeader, ListItemParagraph, } from './list';
const ListItem = InnerListItem;
ListItem.Header = ListItemHeader;
ListItem.Paragraph = ListItemParagraph;
const List = InnerList;
List.Item = ListItem;
export default List;
